import initialStepValidation from './initialStepValidation';
const apiUrls = require('../../../constants/apiUrls');

export default (state, orderId) => {

  const workOrderDetails = state.getIn([
    'workOrderDetails',
    orderId
  ]);

  const currentStatus = workOrderDetails.getIn([
    'orderClose',
    'details',
    'closeOrderRequest',
    'orderStatus'
  ]);

  const serviceTypeId = workOrderDetails.getIn([
    'schedulingSystemDetails',
    'details',
    'serviceOrderInfoV2',
    'serviceTypeId',
  ]);

  const signalLevels = workOrderDetails.getIn([
    'orderClose',
    'details',
    'closeOrderRequest',
    'signalLevel'
  ]);

  const errors = workOrderDetails.getIn([
    'orderClose',
    'details',
    'signalLevelsDetails',
    'errors'
  ]);

  const currentValidation = workOrderDetails.getIn([
    'orderClose',
    'details',
    'stepValidation'
  ]) || initialStepValidation;

  let isValid = !errors;

  if(currentStatus === "NoAccess" || serviceTypeId.startsWith("SR") || serviceTypeId.startsWith("DI")) {
    return currentValidation.setIn([
      'signalLevels',
      'isValid'
    ], true);
  } else {
    if(signalLevels) {
      const signalLevelForm = {
        techId: signalLevels.get('techId'),
        tapHigh: signalLevels.get('tapHigh'),
        tapLow: signalLevels.get('tapLow'),
        tapTx: signalLevels.get('tapTx'),
        tapRx: signalLevels.get('tapRx'),
        tapMer: signalLevels.get('tapMer'),
        tapDropToHome: signalLevels.get('tapDropToHome'),
        groundBlockHigh: signalLevels.get('groundBlockHigh'),
        groundBlockLow: signalLevels.get('groundBlockLow'),
        groundBlockTx: signalLevels.get('groundBlockTx'),
        groundBlockRx: signalLevels.get('groundBlockRx'),
        groundBlockMer: signalLevels.get('groundBlockMer'),
        groundBlockDropToHome: signalLevels.get('groundBlockDropToHome')
      };

      Object.keys(signalLevelForm)
        .forEach(field => {
          if (typeof signalLevelForm[field] === 'undefined' || signalLevelForm[field] === '') {
            isValid = false;
          }
        });

    } else {
      isValid = apiUrls.BYPASS_SIGNAL_LEVELS;
    }
  }

  return currentValidation.setIn([
    'signalLevels',
    'isValid'
  ], isValid);
};





// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/fstSignalsValidator.js